import { fireLinkTag } from './tagManager';
import { getSiteMode as _getSiteMode } from '~/utils/getSiteMode';
import { viewTypes } from '#shared/constants';

/**
 * New `cm_sp` format
 * Note: for the empty value data elements use na as a default value.
 * e.g. TOP-NAV_21683_WOMEN_CLOTHING_DRESSES_NA_NA
 */
function _getNewCmspFormat(data) {
  return Object.keys(data)
    .reduce((acc, key) => {
      if (key.startsWith('subCategory')) {
        acc.push(`${data[key]?.length ? data[key] : 'NA'}`);
      } else {
        acc.push(data[key]);
      }
      return acc;
    }, [])
    .join('_');
}

function _getTrackingParams(prefixNavType, tracking, { _tagData, isBcomDataValidForNewCmspFormat, productBrowseCategoryId, context }) {
  return Object.entries(tracking || {}).reduce((acc, cur) => {
    const [key, value] = cur;
    acc[key] = typeof value === 'function' ? value(context) : value;

    if (key === 'cm_sp') {
      // need to clean up cm_cp value
      let validCmsp = decodeURIComponent(acc[key]);

      // BCOM new format
      if (isBcomDataValidForNewCmspFormat) {
        validCmsp = _getNewCmspFormat({
          nav_type: prefixNavType,
          productBrowseCategoryId,
          topCategoryName: _tagData.topCategoryName?.length ? _tagData.topCategoryName.toUpperCase() : '',
          subCategory1Name: _tagData.subCategory1Name?.length ? _tagData.subCategory1Name.toUpperCase() : '',
          subCategory2Name: _tagData.subCategory2Name?.length ? _tagData.subCategory2Name.toUpperCase() : '',
          subCategory3Name: _tagData.subCategory3Name?.length ? _tagData.subCategory3Name.toUpperCase() : '',
          subCategory4Name: _tagData.subCategory4Name?.length ? _tagData.subCategory4Name.toUpperCase() : '',
        });
      }

      acc[key] = validCmsp;
    }

    return acc;
  }, {});
}

export function tagNavLinkClick(isMcom, tagData = {}, viewType = null, options = {}) {
  const _tagData = tagData;

  // clean up any extra spaces
  Object.keys(_tagData).forEach((k) => {
    if (typeof _tagData[k] === 'string') _tagData[k] = _tagData[k].trim();
  });

  const {
    // dual brand
    analyticsCategoryId = null,
    categoryId,
    context,
    topCategoryName = '',
    subCategory1Name = '',
    subCategory2Name = '',
    subCategory3Name = '',
    subCategory4Name = '',
    tracking,
    // mcom only
    clickableElement = '',
    col,
    pos,
  } = _tagData;

  const productBrowseCategoryId = analyticsCategoryId || categoryId;

  // one of these keys must have value
  const isBcomDataValidForNewCmspFormat =
    !isMcom &&
    (topCategoryName?.length || subCategory1Name?.length || subCategory2Name?.length || subCategory3Name?.length || subCategory4Name?.length);

  // Setting SHOP-ALL to only BCOM experiences on for desktop
  const prefixNavType = isBcomDataValidForNewCmspFormat && options?.isShopAll && viewType === viewTypes.desktop ? 'SHOP-ALL' : 'TOP-NAV';

  const utagData = {
    event_name: 'nav link click',
    ...(isBcomDataValidForNewCmspFormat
      ? {
          product_browse_category_id: productBrowseCategoryId,
          nav_type: prefixNavType,
          top_category_name: topCategoryName?.length ? topCategoryName.toUpperCase() : '',
          sub_category1_name: subCategory1Name?.length ? subCategory1Name.toUpperCase() : '',
          sub_category2_name: subCategory2Name?.length ? subCategory2Name.toUpperCase() : '',
          sub_category3_name: subCategory3Name?.length ? subCategory3Name.toUpperCase() : '',
          sub_category4_name: subCategory4Name?.length ? subCategory4Name.toUpperCase() : '',
        }
      : {
          category_id: productBrowseCategoryId,
          top_nav_category_name: topCategoryName,
          col,
          pos,
          primary_component: 'glbhdrnav',
          clickable_element: clickableElement,
          mode: _getSiteMode(context),
        }),
    ..._getTrackingParams(prefixNavType, tracking, {
      _tagData,
      isBcomDataValidForNewCmspFormat,
      productBrowseCategoryId,
      context,
    }),
  };

  fireLinkTag(utagData);
}

export default {
  tagNavLinkClick,
};
